import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { PageFrame } from '@/components/shared/PageFrame'
import i18next from 'i18next'

import { settingsQueryOptions } from '@/common/queryOptions'
import { BackorderSettingsFallback } from '@/components/backorders/BackorderSettingsFallback'
import { useSuspenseQuery } from '@tanstack/react-query'
import { BackorderStatusBadge } from '@/components/shared/BackorderStatusBadge'
import { BackorderForm } from '@/components/backorders/BackorderForm'

export const Route = createFileRoute('/backorders/settings')({
  loader: async ({ context: { queryClient }, route: { path } }) => {
    try {
      await queryClient.ensureQueryData(settingsQueryOptions())
    } catch (error) {
      console.error('Error in page loader.', path, error)
      throw error
    }
  },
  pendingComponent: () => {
    return <BackorderSettingsFallback />
  },
  component: Index,
})

function Index() {
  const navigate = useNavigate({ from: '/backorders' })

  const { data: settings } = useSuspenseQuery(settingsQueryOptions())

  return (
    <PageFrame
      title={i18next.t('backorderSettingsTitle')}
      subtitle={i18next.t('backorderSettingsSubtitle')}
      titleMetadata={<BackorderStatusBadge backorderEnabled={!!settings.backorderEnabled} status={settings.backorderStatus} withProgress={false} />}
      backAction={{
        content: i18next.t('backordersDashTitle'),
        onAction: async () => {
          /* @ts-ignore */
          await shopify.saveBar.leaveConfirmation()

          navigate({ to: '/backorders' })
        },
      }}
    >
      <BackorderForm />
    </PageFrame>
  )
}
